import React from 'react';
import PropTypes from 'prop-types';
import { get, has, orderBy } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import moment from 'moment';

class News extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: null,
    };

    this.nextArticle = this.nextArticle.bind(this);
    this.prevArticle = this.prevArticle.bind(this);

    this.setPrevRef = this.setPrevRef.bind(this);
    this.setNextRef = this.setNextRef.bind(this);
  }

  setPrevRef(node) {
    if (this.prevRef) {
      this.prevRef.removeEventListener('click', this.prevArticle);
    }

    this.prevRef = node;
    if (this.prevRef) {
      this.prevRef.addEventListener('click', this.prevArticle);
    }
  }

  setNextRef(node) {
    if (this.nextRef) {
      this.nextRef.removeEventListener('click', this.nextArticle);
    }
    this.nextRef = node;
    if (this.nextRef) {
      this.nextRef.addEventListener('click', this.nextArticle);
    }
  }

  getArticles() {
    const blogposts = orderBy(this.props.blogposts, 'date', 'des').slice(0, 6);

    const current = this.state.current === null ? blogposts.length - 1 : this.state.current;
    let prev = current - 1;
    let next = current + 1;

    if (next > (blogposts.length - 1)) {
      next = 0;
    }

    if (prev < 0) {
      prev = (blogposts.length - 1);
    }

    return {
      prev: blogposts[prev],
      current: blogposts[current],
      next: blogposts[next],
      blogposts,
    };
  }

  prevArticle() {
    const { blogposts } = this.getArticles();
    const previous = this.state.current - 1;

    this.setState({
      current: previous < 0 ? (blogposts.length - 1) : previous,
    });
  }

  nextArticle() {
    const { blogposts } = this.getArticles();
    const next = this.state.current + 1;

    this.setState({
      current: next > (blogposts.length - 1) ? 0 : next,
    });
  }


  render() {
    const { prev, current, next } = this.getArticles();

    return (
      <div className="news">
        <div className="container">
          <div className="wrapper">
            <div className="title">
              <h2 className="underdog">Latest News</h2>
            </div>
            <div className="image-wrapper">
              <div className="prev" style={{ backgroundImage: `url(${buildThumbnailUrl(get(prev, 'logo.contentUrl'), { width: 800, height: 800 })})` }} />
              <Link
                name="latest-news"
                params={{
                  blogpostTitle: get(current, 'title'),
                }}
              >
                <div className="active" style={{ backgroundImage: `url(${buildThumbnailUrl(get(current, 'logo.contentUrl'), { width: 800, height: 800 })})` }} />
              </Link>
              <div className="next" style={{ backgroundImage: `url(${buildThumbnailUrl(get(next, 'logo.contentUrl'), { width: 800, height: 800 })})` }} />
              <div className="prev-arrow noselect" ref={this.setPrevRef}>
                {
                  has(prev, 'date') &&
                  moment(get(prev, 'date')).format('MMM D YYYY').toUpperCase()
                }
              </div>
              <div className="next-arrow noselect" ref={this.setNextRef}>
                {
                  has(next, 'date') &&
                  moment(get(next, 'date')).format('MMM D YYYY').toUpperCase()
                }
              </div>
            </div>
            <div className="date-box">
              {
                has(current, 'date') &&
                moment(get(current, 'date')).format('MMMM D, YYYY')
              }
            </div>
            {/* <div className="headline">
              <h3>
                <Link
                  name="latest-news"
                  params={{
                    blogpostTitle: get(current, 'title'),
                  }}
                >{ get(current, 'title') }
                </Link>
              </h3>
            </div> */}
            <div className="news-link">
              <Link name="latest-news">
                <div className="btn">
                  View All News
                </div>
              </Link>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

News.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object),
};
News.defaultProps = {
  blogposts: [],
};

export default withData({
  blogposts: true,
})(News);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/News.js